import { AxiosError } from 'axios';
import { useState } from 'react';

import { LookMetricsInterface } from '../../../models/dashboard/revenue/lookup-metrics';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { lookupMetricsActions } from '../../../redux/slices/lookupMetrics';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useLookupMetrics = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onLookupError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onLookupSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<LookMetricsInterface>) => {
        dispatch(lookupMetricsActions.setLookupMetrics(data));
    };

    const lookupMetrics = async () => {
        const url: HttpConfig = {
            url: `ba/v1/revenue/lookup-metrics`,
            method: 'get',
        };

        return request(url, onLookupSuccess, setLoading, onLookupError);
    };

    return { lookupMetrics, loading };
};

export default useLookupMetrics;
